<template>
  <div
    class="ao__cnc_html_box"
    v-if="props.payload?.attributes?.src"
    v-html="props.payload?.attributes?.src"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  type: { type: String, required: true },
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})
</script>